/**
 * @desc 财务一级审批人修改数据
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(
  body: defs.fulfilment.WarehouseCostApprovalFinanceReceptionDto,
  options?: any,
) {
  return updateResponse(
    http(URL + `/warehouseCost/finace`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
